import styled from 'styled-components'

import { StyledListWrapper as ListWrapper } from 'components/Lists/ListWrapper/ListWrapper.styled'

export const DebitCardTransactionListWrapper = styled(ListWrapper)<{
  $listHeight?: string
}>`
  height: ${({ $listHeight }) => $listHeight};
`
